import { ApplyOptionsFormActions } from '../reducer';

export function completeState(dispatch, productOptions) {
  const formData = {};
  productOptions.forEach(productOption => {
    formData[productOption.name] = { value: false, label: 'None' };
  });
  dispatch({ type: ApplyOptionsFormActions.SET_FORM_VALUE, payload: formData });
}
